export default {
    label_apply: 'Применить',
    chart_information: 'Описание графика',
    percentile_50: '50% задач было решено за {value} {dayLabel} или меньше',
    percentile_85: '85% задач было решено за {value} {dayLabel} или меньше',
    percentile_95: '95 % задач было решено за {value} {dayLabel} или меньше',
    percentile_short_50: '50% за {value} {dayLabel}',
    percentile_short_85: '85% за {value} {dayLabel}',
    percentile_short_95: '95 % за {value} {dayLabel}',
    label_days: 'Дни',
    label_count: 'Кол-во',
    label_pc: 'шт',
    label_cfd_nodata: 'Нет задач подходящих под условия фильтров',
    label_save: 'Сохранить',
    label_delete: 'Удалить',
    label_name: 'Имя',
    label_description: 'Описание',
    label_edit: 'Редактировать',
    label_reset: 'Сбросить',
    label_confirm: 'Подтвердить',
    label_close: 'Закрыть',
    label_cancel: 'Отмена',
    label_save_changes: 'Сохранить изменения',
    label_clear: 'Очистить',
    label_rename: 'Переименовать',
    label_yes: 'Да',
    label_no: 'Нет',
};
